import { render } from "./NewManualIncoming.vue?vue&type=template&id=2b1f72bb"
import script from "./NewManualIncoming.vue?vue&type=script&lang=js"
export * from "./NewManualIncoming.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__